import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-input',
  template: `
    <input
      type="text"
      class="form-control"
      [id]="id"
      [placeholder]="placeholder"
      [disabled]="disabled"
    />
  `,
   standalone: true
})
export class ZikataInputComponent {
  @Input() id = '';
  @Input() placeholder = '';
  @Input() disabled = false;
}
